import type { CRMUser, Subtask } from '../types';
import { crmUserLabel } from './actionRequiredDisplay';

export const OPS_CHECKLIST_UNASSIGNED_KEY = '__unassigned__';

export function sortOpsChecklistItems(items: Subtask[]): Subtask[] {
  return [...items].sort((a, b) => a.position - b.position);
}

export function groupOpsChecklistByAssignee(
  items: Subtask[],
  teamMembers: CRMUser[],
): { key: string; label: string; items: Subtask[] }[] {
  const sorted = sortOpsChecklistItems(items);
  const buckets = new Map<string, Subtask[]>();

  for (const item of sorted) {
    const key = item.assignedTo?.trim() || OPS_CHECKLIST_UNASSIGNED_KEY;
    const list = buckets.get(key) ?? [];
    list.push(item);
    buckets.set(key, list);
  }

  const groups: { key: string; label: string; items: Subtask[] }[] = [];
  for (const [key, groupItems] of Array.from(buckets.entries())) {
    if (key === OPS_CHECKLIST_UNASSIGNED_KEY) continue;
    const user = teamMembers.find((u) => u.uid === key);
    groups.push({
      key,
      label: crmUserLabel(user) || 'Assignee',
      items: groupItems,
    });
  }

  groups.sort((a, b) => a.label.localeCompare(b.label, undefined, { sensitivity: 'base' }));

  const unassigned = buckets.get(OPS_CHECKLIST_UNASSIGNED_KEY);
  if (unassigned?.length) {
    groups.push({ key: OPS_CHECKLIST_UNASSIGNED_KEY, label: 'Unassigned', items: unassigned });
  }

  return groups;
}
